<template>
  <div class="bg bg2">
    <div class="class--con">
      <class-but @forward="forward"/>
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";

export default {
  name: "threePage",
  components: {ClassBut},
  data() {
    return {

    }
  },
  methods: {
    forward() {
      this.$router.push({
        name: 'PageFourth',
        query: this.$route.query,
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import "reportClass.less";
</style>
